export class Documento {
  id: number;
  titulo: string;
  descricao: string;
  tipo: number;
  obrigatorio: boolean;
}
